import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@nutrix/data-access-auth';
import { MessageService } from 'primeng/api';
import { catchError, map, Observable, of, switchMap, throwError } from 'rxjs';

export const InterceptorSkipHeader = 'x-skip-interceptor';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const message = inject(MessageService);
  const router = inject(Router);
  const authService = inject(AuthService);

  if (req.headers.has(InterceptorSkipHeader)) {
    const headers = req.headers.delete(InterceptorSkipHeader);
    return next(req.clone({ headers }));
  }

  const cloned = req.clone({
    withCredentials: true,
    headers: req.headers
      .set('Accept', 'application/json; charset=utf-8')
      .set('Content-Type', 'application/json; charset=utf-8'),
  });

  return next(cloned).pipe(
    switchMap((event: HttpEvent<unknown>): Observable<HttpEvent<unknown>> => {
      return of(event);
    }),
    map((res) => res),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        const isAuthEndpoint = error.url?.includes('/membership/') ?? false;
        const wasLoggedIn = authService.loadCurrentUser() != null;
        if (wasLoggedIn && isAuthEndpoint) {
          message.add({ severity: 'error', summary: 'Autenticación', detail: 'Debes iniciar sesión nuevamente' });
          router.navigate(['login']);
        }
      }
      return throwError(() => error);
    }),
  );
};
